import React from 'react';
import styles from '../css/reports.module.css';
import { useState } from 'react';
import { exportToExcel } from '../helpers/exportToExcel';

function ActivityRpt({ reportData }) {
  // Check if reportData is an array
  // console.log(
  //   'reportData:',
  //   Array.isArray(reportData),);

  const [page, setPage] = useState(1);
  const ITEMS_PER_PAGE = 35;

  //   Example data array. In real use, this would come from props or state.
  //Output only for demonstration purposes. Output a list of items for the current page with navigation buttons.
  // const dataTest = Array.from(
  //   { length: 50 },
  //   (_, i) => `Item ${i + 1}`,
  // );

  const start = (page - 1) * ITEMS_PER_PAGE;
  const end = start + ITEMS_PER_PAGE;
  const currentItems = reportData.slice(start, end);

  const totalPages = Math.ceil(reportData.length / ITEMS_PER_PAGE);

  return (
    <div>
      <div>
        <div>
          <button
            disabled={reportData.length === 0 ? true : false}
            style={reportData.length === 0 ? { opacity: 0.5, display: 'none' } : {}}
            className={styles.reportButton}
            onClick={() => exportToExcel(reportData, 'ActivityReport')}
          >
            Export to Excel
          </button>
        </div>
        <div>
          {reportData.length > 0 ? (
            <table className={styles.reportTable}>
              <caption>Daily Activities Table</caption>
              <thead>
                <tr>
                  <th>Ticket</th>
                  <th>Section</th>
                  <th>Lane</th>
                  <th>Space</th>
                  <th>Date In</th>
                  <th>Time In</th>
                  <th>Date Out</th>
                  <th>Time Out</th>
                  <th>Car Make</th>
                  <th>Car Color</th>
                  <th>License Plate</th>
                </tr>
              </thead>
              <tbody>
                {currentItems.map((item) => (
                  <tr key={item.Ticket}>
                    <td>{item.Ticket}</td>
                    <td>{item.SectionName}</td>
                    <td>{item.LaneNum}</td>
                    <td>{item.SpaceNum}</td>
                    <td>{new Date(item.DateTimeIn).toLocaleDateString()}</td>
                    <td>{new Date(item.DateTimeIn).toLocaleTimeString()}</td>
                    <td>{new Date(item.DateTimeOut).toLocaleDateString()}</td>
                    <td>{new Date(item.DateTimeOut).toLocaleTimeString()}</td>
                    <td>{item.CarMake}</td>
                    <td>{item.CarColor}</td>
                    <td>{item.LicensePlate}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className={styles.noDataMessage}>No activity report data available.</div>
          )}
        </div>
        <div
          style={reportData.length === 0 ? { display: 'none', opacity: 0 } : {}}
          className={styles.paginationButtons}
        >
          <button disabled={page === 1} className={styles.nextButton} onClick={() => setPage(1)}>
            {'<<'}
          </button>
          <button disabled={page === 1} className={styles.prevButton} onClick={() => setPage(page - 1)}>
            {'< Prev'}
          </button>

          <span style={{ width: '200px', textAlign: 'center' }}>
            {' '}
            Page {page} of {totalPages}{' '}
          </span>

          <button disabled={page === totalPages} className={styles.nextButton} onClick={() => setPage(page + 1)}>
            {'Next >'}
          </button>
          <button disabled={page === totalPages} className={styles.nextButton} onClick={() => setPage(totalPages)}>
            {'>>'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ActivityRpt;
